export default [
  /** LINE儲值 */
  {
    path: '/line-recharge',
    name: 'LineRecharge',
    component: () => import('@/upgrade-page/views/line-recharge/index')
  },
  /** line分享 */
  {
    path: '/line-share/:code?',
    name: 'LineShare',
    component: () => import('@/upgrade-page/views/line-share/index')
  },
  /** 登錄（頁面，非彈窗） */
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/upgrade-page/views/login/index'),
    meta: {
      hideNav: true,
      hideFooter: true
    }
  },
  // 容錯處理，老版个人详情页，重定向到新版个人详情页
  {
    path: '/:uuid(\\d+)/:skill(\\d+)?',
    name: 'MasterDetail',
    redirect(from) {
      return {
        name: 'playerDetail',
        query: { skillId: from.params.skill },
        params: { uuid: from.params.uuid }
      };
    }
  },
  {
    path: '/:uuid(ref\\w+)',
    name: 'RefMasterDetail',
    redirect(from) {
      return {
        name: 'playerDetail',
        query: {},
        params: { uuid: from.params.uuid }
      };
    }
  },
  {
    path: '/invite/:inviteCode',
    name: 'invitePage',
    component: () => import('@/upgrade-page/views/invite/invite-page'),
    meta: {
      hideNav: false,
      hideFooter: true
    }
  },
  /** 声鉴卡制作 */
  {
    path: '/make-vocality-card',
    name: 'MakeVocalityCard',
    component: () => import('@/upgrade-page/views/make-vocality-card/index'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true,
      needLogin: true
    }
  },
  /** LINE儲值 */
  {
    path: '/aPullc',
    name: 'APullc',
    component: () => import('@/upgrade-page/views/aPullc/index')
  },
  {
    path: '*',
    redirect: '/'
  }
];
